import { Box, Grid, Stack, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import tomo1 from "../../../assets/resFinal/vassoio2.png";
import tomo3 from "../../../assets/resFinal/saune.JPG";
import { Trans, useTranslation } from "react-i18next";
import MasonryGrid from "../../../components/UI/MasonryGrid/MasonryGrid";

type Props = {
  isPageSingle?: boolean;
  isRooms?: boolean;
};
const SectionTwoStableMob = ({ isPageSingle, isRooms }: Props) => {
  const isLgScreen = useMediaQuery("(min-width:1600px)");
  const isMobile = useMediaQuery("(max-width: 768px)");
  const isTablet = useMediaQuery("(max-width: 768px)");
  const { t } = useTranslation();

  return (
    <Grid
      container
      sx={{
        margin: "0 auto",
        maxWidth: isLgScreen ? "2200px" : "100%",
      }}
    >
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Stack
          direction="row"
          spacing={isLgScreen ? 2 : 2}
          padding={1}
          sx={{
            zIndex: 4,
            width: isMobile ? "100%" : "80%",
            display: "flex",
            height: "100%",
            maxWidth: isMobile ? "330px" : undefined,
            padding: isMobile
              ? "0 0 50px 0"
              : isRooms && !isMobile
              ? 10
              : undefined,
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Box width={"100%"}>
            <Typography
              sx={{
                p: 8,
                display: isMobile || isRooms ? "block" : "none",
                py: 3,
                color: isMobile ? "#000" : "#1f5f91",
                letterSpacing: isMobile ? undefined : "2px",
              }}
              variant={"h3"}
              lineHeight={"24px"}
              fontSize={isMobile ? "20px" : isTablet ? "24px" : "32px"}
              fontWeight="300"
              textAlign="center"
              fontStyle={isMobile ? "italic" : "italic"}
            >
              <Trans
                i18nKey="brochure_service"
                components={{
                  bold: <b style={{ fontWeight: 500 }} />,
                  italic: <i />,
                }}
              />
            </Typography>
            <Typography
              variant="body1"
              lineHeight={isMobile ? "22px" : isTablet ? 1.5 : "28px"}
              fontSize={isMobile ? "13px" : isTablet ? "16px" : "16px"}
              fontWeight="400"
              textAlign="center"
              marginBottom={2}
              style={{
                margin: isMobile ? 0 : 20,
              }}
            >
              <Trans
                i18nKey="brochure_section_9"
                components={{
                  bold: <b style={{ fontWeight: 500 }} />,
                  italic: <i />,
                }}
              />
            </Typography>
          </Box>
        </Stack>
        {isMobile ? (
          <Stack
            spacing={1}
            style={{
              width: isMobile ? undefined : "100%",
              justifyContent: isMobile ? undefined : "center",
              display: isPageSingle ? "none" : "flex",
            }}
            direction={"row"}
          >
            <Box
              style={{
                width: isMobile ? "50%" : "50%",
                zIndex: 3,
                height: "100%",
                maxHeight: isMobile ? "300px" : "600px",
              }}
            >
              <img
                src={tomo1}
                alt="Kitchen"
                loading="lazy"
                style={{
                  width: "100%",
                  objectFit: "cover",
                  height: "100%",
                  zIndex: 3,
                }}
              />
            </Box>
            <Box
              style={{
                width: isMobile ? "50%" : "50%",
                zIndex: 3,
                height: "100%",
                maxHeight: isMobile ? "300px" : "600px",
              }}
            >
              <img
                src={tomo3}
                alt="Kitchen"
                loading="lazy"
                style={{
                  width: "100%",
                  objectFit: "cover",
                  height: "100%",
                  zIndex: 3,
                }}
              />
            </Box>
          </Stack>
        ) : (
          <MasonryGrid />
        )}
      </Box>
    </Grid>
  );
};

export default SectionTwoStableMob;
